export enum ELogisticsStepsAccreditationStatus {
  adminApproves = 'ADMIN_APPROVES',
  sign = 'SIGN',
  approved = 'APPROVED',
}
